/* ==========================================================================
   FB TRANSITION — loading-scene + page transitions
   Styres af data-attributter paa #fbt-overlay (saettes fra snippet'et).
   Fail-safe: overlayet fjernes ALTID efter faldback-timeout, saa butikken
   aldrig kan blive haengende bag en sort plade.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var overlay = document.getElementById('fbt-overlay');
  if (!overlay) return;

  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) {
    root.classList.remove('fbt-active', 'fbt-leaving');
    return;
  }

  var cfg = {
    effect: overlay.dataset.effect || 'mosaic',
    duration: parseInt(overlay.dataset.duration, 10) || 620,
    intro: overlay.dataset.intro === 'true',
    introOncePerSession: overlay.dataset.introOnce === 'true',
    navigate: overlay.dataset.navigate === 'true',
    logoFlip: overlay.dataset.logoFlip === 'true',
    // Mindste og stoerste tid scenen maa vaere paa skaermen
    minShow: parseInt(overlay.dataset.minShow, 10) || 320,
    maxShow: parseInt(overlay.dataset.maxShow, 10) || 1400
  };

  // Absolut oevre graense: uanset hvad forsvinder overlayet efter dette.
  var FAILSAFE_MS = Math.min(Math.max(cfg.duration * 3, 1600), 2500);
  var failsafeTimer = null;

  function armFailsafe() {
    clearTimeout(failsafeTimer);
    failsafeTimer = setTimeout(reveal, FAILSAFE_MS);
  }

  /* ---------------------------------------------------------------------
     Mosaic-fliser: bygges dynamisk saa antallet foelger CSS-variablerne
     --------------------------------------------------------------------- */
  function buildTiles() {
    if (cfg.effect !== 'mosaic') return;
    var styles = getComputedStyle(root);
    var cols = parseInt(styles.getPropertyValue('--fbt-cols'), 10) || 3;
    var rows = parseInt(styles.getPropertyValue('--fbt-rows'), 10) || 6;
    var total = cols * rows;

    if (overlay.querySelectorAll('.fbt-tile').length === total) return;

    var logo = overlay.querySelector('.fbt-logo');
    overlay.querySelectorAll('.fbt-tile').forEach(function (t) {
      t.remove();
    });

    var frag = document.createDocumentFragment();
    for (var i = 0; i < total; i++) {
      var tile = document.createElement('div');
      tile.className = 'fbt-tile';
      // Diagonal forskydning giver den boelge Flowbit koerer
      var col = i % cols;
      var row = Math.floor(i / cols);
      var delay = (col + row) * 34;
      tile.style.setProperty('--fbt-tile-delay', delay + 'ms');
      frag.appendChild(tile);
    }
    overlay.insertBefore(frag, logo || null);
  }

  /* ---------------------------------------------------------------------
     Counter 0-100
     --------------------------------------------------------------------- */
  var counterRAF = null;

  function runCounter(ms) {
    var el = overlay.querySelector('.fbt-counter');
    var fill = overlay.querySelector('.fbt-bar__fill');
    if (!el) return;
    var start = performance.now();

    function step(now) {
      var p = Math.min((now - start) / ms, 1);
      // easeOutExpo, saa den bremser op mod 100
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      el.textContent = String(Math.round(eased * 100)).padStart(3, '0');
      if (fill) fill.style.transform = 'scaleX(' + eased + ')';
      if (p < 1) counterRAF = requestAnimationFrame(step);
    }
    counterRAF = requestAnimationFrame(step);
  }

  /* ---------------------------------------------------------------------
     Vis / skjul
     --------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------
     LOGO-FLIP — logoet flyver mellem headeren og midten af overlayet,
     saa det ser ud som om loading-scenen "folder sig ud" fra headeren.
     --------------------------------------------------------------------- */
  var logo = overlay.querySelector('.fbt-logo');

  function headerLogoRect() {
    var el = document.querySelector('.fb-hd__logo-img, .fb-hd__wordmark');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    return r;
  }

  function flipLogo(direction, ms) {
    // direction: 'in'  = fra header ind mod midten (naar vi forlader siden)
    //            'out' = fra midten ud i headeren (naar siden aabner)
    // I spin-tilstand roterer logoet allerede, saa flip ville slaas med den
    if (!logo || !cfg.logoFlip || cfg.effect === 'spin') return;

    var target = headerLogoRect();
    if (!target) return;

    var mid = logo.getBoundingClientRect();
    if (!mid.width || !mid.height) return;

    var dx = target.left + target.width / 2 - (mid.left + mid.width / 2);
    var dy = target.top + target.height / 2 - (mid.top + mid.height / 2);
    var scale = Math.max(target.width / mid.width, 0.04);

    var atHeader = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
    var atCenter = 'translate(0,0) scale(1)';

    var from = direction === 'in' ? atHeader : atCenter;
    var to = direction === 'in' ? atCenter : atHeader;

    logo.style.transition = 'none';
    logo.style.transform = from;
    logo.style.opacity = direction === 'in' ? '0.2' : '1';

    // Tving reflow saa browseren registrerer startpunktet
    void logo.offsetWidth;

    logo.style.transition =
      'transform ' + ms + 'ms var(--fb-ease, cubic-bezier(0.22,1,0.36,1)), ' +
      'opacity ' + Math.round(ms * 0.7) + 'ms ease';
    logo.style.transform = to;
    logo.style.opacity = direction === 'in' ? '1' : '0';
  }

  function resetLogo() {
    if (!logo) return;
    logo.style.transition = '';
    logo.style.transform = '';
    logo.style.opacity = '';
  }

  function reveal() {
    clearTimeout(failsafeTimer);
    if (counterRAF) cancelAnimationFrame(counterRAF);
    // Logoet trkker sig op i headeren mens pladen forsvinder
    flipLogo('out', cfg.duration);
    root.classList.remove('fbt-active');
    root.classList.remove('fbt-leaving');
    setTimeout(resetLogo, cfg.duration + 60);
  }

  function cover(done) {
    buildTiles();
    root.classList.add('fbt-leaving');
    root.classList.add('fbt-active');
    // Logoet vokser ud af headeren og ind i midten
    flipLogo('in', cfg.duration);
    if (cfg.effect === 'counter') runCounter(cfg.duration);
    armFailsafe();
    // Mosaic har forskudt delay, saa der skal laegges lidt tid til
    var extra = cfg.effect === 'mosaic' ? 220 : 0;
    setTimeout(done, cfg.duration + extra);
  }

  /* ---------------------------------------------------------------------
     INTRO — foerste load
     --------------------------------------------------------------------- */
  function shouldPlayIntro() {
    if (!cfg.intro) return false;
    if (!cfg.introOncePerSession) return true;
    try {
      if (sessionStorage.getItem('fbt-intro-seen') === '1') return false;
      sessionStorage.setItem('fbt-intro-seen', '1');
    } catch (e) {
      /* private mode: spil bare introen */
    }
    return true;
  }

  if (shouldPlayIntro()) {
    buildTiles();
    root.classList.add('fbt-active');
    if (cfg.effect === 'counter') runCounter(cfg.duration);
    armFailsafe();

    // Vi venter IKKE paa window.load. Den fyrer foerst naar hvert eneste
    // billede og hver video er hentet, og det er flere sekunder sort skaerm
    // paa en tung produktside. Vi loefter naar DOM'en staar, med en kort
    // mindstetid saa scenen ikke bare blinker, og en haard oevre graense.
    var lifted = false;
    var startedAt = Date.now();

    var lift = function () {
      if (lifted) return;
      lifted = true;
      var minShow = cfg.effect === 'counter' ? cfg.duration : cfg.minShow;
      var waited = Date.now() - startedAt;
      setTimeout(reveal, Math.max(0, minShow - waited));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lift, { once: true });
    } else {
      lift();
    }

    // Haard graense: uanset hvad er scenen vaek efter dette
    setTimeout(lift, cfg.maxShow);
  } else {
    reveal();
  }

  /* ---------------------------------------------------------------------
     NAVIGATION — daek af foer vi forlader siden
     --------------------------------------------------------------------- */
  function isPlainLeftClick(e) {
    return (
      e.button === 0 &&
      !e.metaKey &&
      !e.ctrlKey &&
      !e.shiftKey &&
      !e.altKey &&
      !e.defaultPrevented
    );
  }

  function shouldIntercept(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.dataset.noTransition !== undefined) return false;
    if (a.getAttribute('rel') === 'external') return false;

    var url;
    try {
      url = new URL(a.href, location.href);
    } catch (err) {
      return false;
    }

    if (url.origin !== location.origin) return false;
    // Rene ankre paa samme side
    if (url.pathname === location.pathname && url.hash) return false;
    if (a.getAttribute('href').charAt(0) === '#') return false;
    if (!/^https?:$/.test(url.protocol)) return false;

    // Lad Shopify styre kurv, checkout og konto-flows uroert
    if (/^\/(cart|checkout|account)(\/|$)/.test(url.pathname)) return false;
    if (/\/cart\/(add|change|update|clear)/.test(url.pathname)) return false;

    return true;
  }

  if (cfg.navigate) {
    document.addEventListener(
      'click',
      function (e) {
        if (!isPlainLeftClick(e)) return;
        var a = e.target.closest && e.target.closest('a[href]');
        if (!shouldIntercept(a)) return;

        e.preventDefault();
        var href = a.href;
        cover(function () {
          window.location.href = href;
        });
      },
      false
    );
  }

  /* ---------------------------------------------------------------------
     bfcache: gaar man tilbage, skal overlayet vaere vaek med det samme
     --------------------------------------------------------------------- */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) reveal();
  });

  // Genopbyg fliser hvis grid-taellingen aendrer sig ved resize
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(buildTiles, 200);
  });
})();
